"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var FacebookSearchDataSource =
/*#__PURE__*/
function () {
  function FacebookSearchDataSource() {
    (0, _classCallCheck2["default"])(this, FacebookSearchDataSource);
  }

  (0, _createClass2["default"])(FacebookSearchDataSource, null, [{
    key: "getName",
    value: function getName() {
      return 'Facebook Search';
    }
  }, {
    key: "getDataRequestBody",
    value: function getDataRequestBody() {
      return {
        sp: '1MrUcKJjpSPblhSAJHiQ9bHle4buOTSxsuxLtmew6dPGy9ZMES7BvdORMMs4/ZSDkBFS4mr+cWd7t0jklvvX5qBNZrFz6bEleSQboxnHsb7q/T6x+jpg/ewaNeZjsygZsYr9mz59MdpQvUvCyZX5I6i33JMLJ4HSOTNo/q0he3oTQqOiT6Un1qQfPLF5QfT4dyG6315/LIiBZ/YGyovu27rZ1hppa+oQNo3W3HP2DrsL93GlM53oaqktNd5pTLOv6SC3ei1p7zavT2/kqqA9DCMZ+Yzl6WWqxCW2ARN1LikGYZoidIfhTKsvAdv82DAdDGi0vjgpeLt1G+ltnnW9CL8+9p2tTA22AEi3j6EtnNoh4ZRMgOzYnGzrNw9faVrMRLtEOe3UeqClu9durPl4HDw3JAYPaNF3k8nLm6uR4iv7AsgX189j0PIi7fyAoBYkQQVicx9UCD3O3BnSv0mCYssg9TEgI5NGV7NIRJFlrTxeAlBpIRcDUTIFLCb76nX/py2g5AIFf640LwcIU7QmdUL7ppdJ/bEst5VhGtdsb+LM0ZwkVJHsduD2JpswUgf2Rlk7sTREGBOaUgICx2Op7qJMkeasGPugLz9Z8vlXVTMKC3kjmDX4E6QPcviih5VD44QlgU6zLG9+1gMttUpE3D6HJP7j2e1odAQeiEY2cS4s42z6D2G/eJL89aBUUPK71daahBwAoyn5dhjvBSEqyPeLYV3+iKifKKp7Heq66gA=',
        wsid: 'f61d92f3-151c-4a5b-a964-7a6853a6e633',
        item: [],
        trackback: null,
        env: 'dev',
        brand: 'RE-SITEBUILDER'
      };
    }
  }, {
    key: "mapResult",
    value: function mapResult(result) {
      if (!result || !result.filter) {
        return [];
      }

      var mappedResult = result.filter(function (item) {
        return item.type.toLowerCase() === 'facebook';
      }).map(function (item, index) {
        return {
          title: item.name,
          image: {
            value: item.picture && item.picture.data.url
          },
          id: item.id
        };
      });
      return mappedResult;
    }
  }, {
    key: "getDataPromise",
    value: function getDataPromise(value) {
      var body = this.getDataRequestBody();
      var item = [{
        id: '9a1f0960-986e-48e5-bd8e-f393f63abf49',
        value: value
      }];
      body.item = item;
      return body;
    }
  }, {
    key: "getFacebookIdFromInput",
    value: function getFacebookIdFromInput(input) {
      // Attempt to get a facebook id from an url
      if (input && input.length > 0) {
        // Remove query parameters
        var mainUrl = input.split('?')[0]; // Check if the input is a url

        var isUrl = mainUrl.indexOf('/') > -1;
        var facebookName = mainUrl;

        if (isUrl) {
          facebookName = this.getFacebookNameFromUrl(mainUrl);
        } // Check if the last part of the facebook name contains an id
        // For example example-barber-shop-2294048793439214


        var digits = facebookName.match(/\d+/);

        if (digits && digits.length > 0) {
          var parsedDigits = digits[0]; // Return the digits if it has enough characters

          var minFacebookIdLength = 4;

          if (parsedDigits.length > minFacebookIdLength) {
            return parsedDigits;
          }
        }

        return facebookName;
      }

      return input;
    }
  }, {
    key: "convertFunction",
    value: function convertFunction(value) {
      return this.getFacebookIdFromInput(value);
    }
  }]);
  return FacebookSearchDataSource;
}();

FacebookSearchDataSource.getFacebookNameFromUrl = function (mainUrl) {
  // Attempt to get the value after the last "/"
  var facebookNameParts = mainUrl.match(/\/([^/]+)\/?$/);

  if (facebookNameParts.length > 1) {
    return facebookNameParts[1];
  }

  return mainUrl;
};

var _default = FacebookSearchDataSource;
exports["default"] = _default;